import React, { useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import { authAPI } from '../api/api';
import { useAuth } from '../context/AuthContext';

export default function ChildPermissionsPage() {
  const { user, updateUser } = useAuth();
  const [saving, setSaving] = useState(false);

  const initial = useMemo(() => ({
    camera: !!user?.permissions?.camera,
    microphone: !!user?.permissions?.microphone,
    location: user?.permissions?.location !== false,
    screenShare: !!user?.permissions?.screenShare,
  }), [user]);

  const [permissions, setPermissions] = useState(initial);

  const toggle = (key) => {
    setPermissions((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const save = async () => {
    setSaving(true);
    try {
      const payload = {
        camera: permissions.camera,
        microphone: permissions.microphone,
        location: permissions.location,
        screenShare: permissions.screenShare,
      };
      const res = await authAPI.updatePermissions(payload);
      updateUser({ permissions: res.data.permissions });
      toast.success('Permissions updated');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Could not save permissions');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="card hero-card" style={{ marginBottom: 20 }}>
        <div className="hero-title">Your Permission Center 🛡️</div>
        <div className="hero-subtitle">Choose what your parent can request. You are always in control.</div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-header">
          <div className="card-title">Permission Controls</div>
        </div>

        <div className="permission-item">
          <div className="permission-info">
            <div className="permission-name">📷 Camera Access</div>
            <div className="permission-desc">Allow camera monitoring requests.</div>
          </div>
          <button className={`toggle ${permissions.camera ? 'on' : ''}`} onClick={() => toggle('camera')}>
            <span className="toggle-knob" />
          </button>
        </div>

        <div className="permission-item">
          <div className="permission-info">
            <div className="permission-name">🎤 Microphone Access</div>
            <div className="permission-desc">Allow microphone listening requests.</div>
          </div>
          <button className={`toggle ${permissions.microphone ? 'on' : ''}`} onClick={() => toggle('microphone')}>
            <span className="toggle-knob" />
          </button>
        </div>

        <div className="permission-item">
          <div className="permission-info">
            <div className="permission-name">📍 Live Location</div>
            <div className="permission-desc">Share your location for safety.</div>
          </div>
          <button className={`toggle ${permissions.location ? 'on' : ''}`} onClick={() => toggle('location')}>
            <span className="toggle-knob" />
          </button>
        </div>

        <div className="permission-item">
          <div className="permission-info">
            <div className="permission-name">🖥️ Screen Share</div>
            <div className="permission-desc">Allow screen sharing requests.</div>
          </div>
          <button className={`toggle ${permissions.screenShare ? 'on' : ''}`} onClick={() => toggle('screenShare')}>
            <span className="toggle-knob" />
          </button>
        </div>
      </div>

      <button className="btn btn-primary" onClick={save} disabled={saving}>
        {saving ? 'Saving...' : 'Save Permissions'}
      </button>
    </div>
  );
}
